import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AxiosError } from 'axios'
import { ValidateAliasBody } from '@/types'
import { removeNonNumeric } from '@/helpers'

export async function validateAlias(body: ValidateAliasBody) {
  const response = await httpClient('user-manager').post(
    '/v1/user/me/alias/validate',
    {
      ...body,
      alias: body.alias_type === 'phone' ? removeNonNumeric(body.alias) : body.alias,
    },
  )

  return response.data
}

export function useValidateAlias(
  options?: UseMutationOptions<unknown, AxiosError, ValidateAliasBody, unknown>,
) {
  return useMutation({
    mutationFn: validateAlias,
    ...options,
  })
}
